export const PRIVATE_PARTY_EVENTS = {
  WIDGET_VIEW: 'private-party.widget_view',
  START_LISTING: 'private-party.start_listing',
  SUBMIT_SURVEY: 'private-party.submit_survey',
  CLOSE_POPUP: 'private-party.close_popup',
  EMAIL_INPUT: 'private-party.email_input',
  ENTER_EMAIL_YMMS: 'private-party.enter_email_ymms',
  YEAR_SELECT: 'private-party.year_select',
  MAKE_SELECT: 'private-party.make_select',
  MODEL_SELECT: 'private-party.model_select',
  STYLE_SELECT: 'private-party.style_select',
  SIGN_UP: 'private-party.sign_up',
  ENTER_PLATE_INPUT: 'private-party.license_plate_input',
  SELECT_STATE_INPUT: 'private-party.license_plate_state_input',
  VIN_INPUT: 'private-party.vin_input',
  LISTING_STYLE_SELECT: 'private-party.listing_style_select',
  STYLE_DECODE: 'private-party.create_style_decode',
  SUBMIT_VEHICLE_DETAILS: 'private-party.submit_vehicle_details',
  SELECT_PHOTOS: 'private-party.select_photos',
  REMOVE_PHOTO: 'private-party.remove-photo',
  CONTINUE: 'private-party.continue',
  PRICE_INPUT: 'private-party.price_input',
  SUBMIT_LISTING: 'private-party.submit_listing',
  MANAGE_LISTING: 'private-party.manage_listing',
  SELLER_INFO_INPUT: 'private-party.seller-info-input',
  NOT_APPROVED_REASONS: 'private-party.not_approved_reasons',
  NOT_APPROVED_BUTTON: 'private-party.not_approved_button',
  API_SYSTEM_ERROR: 'private-party.api-system-error',
  SHARE_CONTENT: 'private-party.share-content',
  SUMMARY_CHECKOUT: 'private-party.summary-checkout',
  CREATE_DEAL: 'private-party.create-deal',
  START_PP_LISTING: 'private-party.start_pp_listing',
  CARAMEL_WEBSITE_CLICKOUT: 'private-party.caramel_website_clickout',
};
